export class translateOthersToEnglishInputModel {
    textToTranslate: string;
    updatesId: number;
    tableName: string;
    constructor() {
        this.textToTranslate = '';
        this.updatesId = 0;
        this.tableName = '';
    }
}